import { useMemo } from 'react'
import EntitiesSelector from '../EntitiesSelector'

const HospitalDepartmentsSelector = ({
  className = '', checkable = false, disabled, dropdownMatchSelectWidth, dropdownStyle, hospitalDepartments, loading, maxTagCount, maxTagPlaceholder,
  multiple = 'default', placeholder = '', selectorClassName, showSearch = false, style = {}, tagPlaceholder, values, onChange
}) => {
  const options = useMemo(() => hospitalDepartments.map(department => ({
    label: department.name,
    value: department.id,
    tooltip: department.name,
    entity: department
  })), [hospitalDepartments])

  return (
    <EntitiesSelector
      checkable={checkable}
      className={className}
      disabled={disabled}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      dropdownStyle={dropdownStyle}
      loading={loading}
      entityOptions={options}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      multiple={multiple}
      placeholder={placeholder}
      selectorClassName={selectorClassName}
      showSearch={showSearch}
      style={style}
      tagPlaceholder={tagPlaceholder}
      values={values}
      onChange={onChange}
    />
  )
}

export default HospitalDepartmentsSelector
